import React from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import { connect } from "react-redux";

// import {
//   getSectionHeaderColor,
//   getSectionHeaderFont,
//   getSectionHeaderSize
// } from "Portal/NewPortal/PortalHome/selectors";

import styles from "./styles.scss";

import { isEmptyOrNil } from "utils/General";

import { Mobile } from "Portal/NewPortal/Shared/MediasQuery";

// import {
//   getPortalUserName,
//   getPortalUserEmail,
//   getPortalUserPhoto
// } from "Portal/NewPortal/HeaderBar/selectors";
// import { getBackgroundColor } from "Portal/NewPortal/PortalHome/selectors";

import EventList from "./EventList";

import Toolbar from "./Toolbar";

import { getMobileSearchCalendarData } from "../selectors";

const decorate = R.compose(
  connect(
    state => ({
      // sectionHeaderColor: getSectionHeaderColor(state),
      // sectionHeaderFont: getSectionHeaderFont(state),
      // sectionHeaderSize: getSectionHeaderSize(state),
      // backgroundColor: getBackgroundColor(state),

      mobileCalendarData: getMobileSearchCalendarData(state)
    }),
    {}
  ),
  CSSModules(styles)
);

const MobileView = ({ mobileCalendarData = {} }) => {
  return (
    <Mobile>
      <div className={styles.rightContainer}>
        <Toolbar />
        {!isEmptyOrNil(mobileCalendarData) && (
          <EventList calendarData={mobileCalendarData} />
        )}
        {isEmptyOrNil(mobileCalendarData) && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "18px"
            }}
          >
            You don't have upcoming events.
          </div>
        )}
      </div>
    </Mobile>
  );
};

export default decorate(MobileView);
